import { render, staticRenderFns } from "./ComposeModal.vue?vue&type=template&id=b22acb78"
import script from "./ComposeModal.vue?vue&type=script&lang=js"
export * from "./ComposeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports